import { axiosProvider } from '@/app/core/axios';
import { getProductRouterPath } from '@/app/features/products/utils';
import {
  CreateTemplateApiResponse,
  CreateTemplateResponse,
  JobsApiSearchResponse,
  JobsSearchResponse,
  SearchRequest,
  TemplatesApiSearchResponse,
  TemplatesSearchResponse,
  TemplatesArchiveResponse,
} from '@ssar-app/domain';
import { stringify } from 'qs';

export const createTemplateByProgramById = (
  programId: string,
  externalSystemRef: string,
  templateName: string,
  templateDesc: string,
): Promise<CreateTemplateResponse> => {
  const payload = {
    programId: programId,
    externalSystemRef: externalSystemRef,
    templateName: templateName,
    templateDesc: templateDesc,
  };
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .post<CreateTemplateApiResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/templates/create-template`,
        payload,
      )
      .then((response) => {
        const data: CreateTemplateApiResponse = response.data;
        if (data.resultCode === 0) {
          resolve(data.data as CreateTemplateResponse);
        } else {
          throw new Error(data?.messages[0]);
        }
      })
      .catch((error) => {
        reject(error.response?.data || error);
      });
  });
};

export const getTemplates = (
  search: SearchRequest,
): Promise<TemplatesSearchResponse> => {
  return new Promise((resolve, reject) => {
    const qsConfig = {
      encodeValuesOnly: true,
      allowDots: true,
    };
    const query = stringify(search, qsConfig);
    axiosProvider.apiClient
      .get<TemplatesApiSearchResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/templates?${query}`,
      )
      .then((response) => {
        if (response) {
          const { data } = response;
          if (data.data) {
            resolve(data.data);
          } else {
            reject('No Templates were found.');
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const archiveTemplate = (
  templateId: string,
): Promise<TemplatesArchiveResponse> => {
  return new Promise((resolve, reject) => {
    axiosProvider.apiClient
      .post<TemplatesArchiveResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/templates/archive-template`,
        {
          templateId,
        },
      )
      .then((response) => {
        if (response?.data) {
          resolve(response.data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getTemplatePrograms = (
  templateId: string,
  search: SearchRequest,
): Promise<JobsSearchResponse> => {
  return new Promise((resolve, reject) => {
    const qsConfig = {
      encodeValuesOnly: true,
      allowDots: true,
    };
    const query = stringify(search, qsConfig);
    axiosProvider.apiClient
      .get<JobsApiSearchResponse>(
        `/program/${encodeURIComponent(
          getProductRouterPath(),
        )}/templates/get-template-programs?${query}&templateId=${templateId}`,
      )
      .then((response) => {
        if (response) {
          const { data } = response;
          if (data.data) {
            resolve(data.data);
          } else {
            reject('No Programs were found.');
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
